import {useCallback, useEffect} from 'react';

import {CarouselEventMessagesType} from 'constants/recommendation';
import ReactNative from 'services/react-native';
import SendBrowserEvent from 'services/send-browser-event';
import {Product} from 'types';

interface UseCarouselEventHandlerProps {
  onSeeAllClick?: (analyticsPayload: any) => void;
  onEmptyCarousel?: (isEmpty: boolean) => void;
}

interface ICarouselMessage {
  product: Product;
  analytics: any;
}
export const useCarouselEventHandler = ({onSeeAllClick, onEmptyCarousel}: UseCarouselEventHandlerProps) => {
  const isReactNativeView = ReactNative.isReactNativeWebView();

  const _closeBasketDrawer = useCallback(() => {
    !isReactNativeView && SendBrowserEvent.closeBasketDrawer();
  }, [isReactNativeView]);

  const handleMessage = useCallback(
    (event: MessageEvent) => {
      try {
        switch (event.data.type) {
          case CarouselEventMessagesType.IFRAME_READY: {
            //todo: set up initial scroll analytics for the carousel
            break;
          }
          case CarouselEventMessagesType.SEE_ALL: {
            const analyticsData = event.data.message;
            onSeeAllClick?.(analyticsData);
            _closeBasketDrawer();
            break;
          }

          case CarouselEventMessagesType.NAVIGATE_PDP_PAGE: {
            const productData = event.data.message as ICarouselMessage;
            const product = productData.product;

            SendBrowserEvent.goBasketRecommendationToPDP(product.id, productData.analytics);

            _closeBasketDrawer();

            break;
          }
          case CarouselEventMessagesType.CAROUSEL_EMPTY: {
            const payload = event.data.message;

            onEmptyCarousel?.(payload);

            break;
          }
        }
      } catch (error) {
        console.error('Invalid message format:', error);
      }
    },
    [_closeBasketDrawer, onEmptyCarousel, onSeeAllClick]
  );

  useEffect(() => {
    window.addEventListener('message', handleMessage, false);
    return () => window.removeEventListener('message', handleMessage);
  }, [handleMessage]);

  return {handleMessage};
};
